// Packages
import { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";

// Styles
import "./superAdmin.css";
// Package
import { Link, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
// views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";
// materia UI
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { CircularProgress, Paper } from "@material-ui/core";
// Services
import userService from "../../services/user.service";
import ReactPlayer from "react-player";
import { BsXLg } from "react-icons/bs";
import PropTypes from "prop-types";
// Assets
import ErrorMessage from "../../Common/ErrorMessage";
import { DataGrid } from "@mui/x-data-grid";
import CustomSearch from "../../Common/CustomSearch";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getFromLocalStorage } from "../../utils/webStorage";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
import DeleteIcon from "@mui/icons-material/Delete";
import ListMenu from "../../Common/ListMenu";
import {
  openFailDialog,
  openSuccessPopup,
} from "../../Redux/Actions/PopupActions";
import { openConfirmationPopup } from "../../Redux/Actions/PopupActions";
import ClearIcon from "@mui/icons-material/Clear";
import { GridCheckCircleIcon } from "@mui/x-data-grid";
class highlightsdetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allSchoolList: [],
      total: null,
      openVideo: false,
      modalId: "",
      openEmail: false,
      modalEmail: "",
      submitting: false,
      shareMediaDetailsResponses: [],
      videoToPlay: "",
      shareMediaId: null,
      totalHighlightRequest: "",
      videoName: "",
      videoPath: "",
      blure: false,
      redirectToHighlight: false,
      pageState: {
        isLoading: false,
        data: [],
        total: 0,
        page: 0,
        pageSize: 10,
      },
      recordNotFound: false,
      searchQuery: "",
      btnText: "",
      successPopup: false,
      msg: "",
      searchedRecord: false,
      recordNotFound: false,
      redirect: false,
      loginRole: getFromLocalStorage("loginRole"),
      rowData: {},
      buttonDisable: false,
    };
  }

  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const Website = document.getElementById("Website");
    const { pageState } = this.state;
    if (Website) {
      Website.classList.add("active");
    }
    this.setState({ submitting: true });
    this.getHighlightsDataByPage(pageState.page, pageState.pageSize);
  }

  getHighlightsDataByPage = (page, size) => {
    const { recordNotFound, pageState } = this.state;
    this.setState({ pageState: { ...pageState, isLoading: true } });
    userService
      .getAllHighlightsRequest(page, size)
      .then((res) => {
        this.setState({
          pageState: {
            ...pageState,
            data: res?.data?.data?.highlightDetailsResponse,
            isLoading: false,
            total: res?.data?.data?.total,
            page: page,
          },
          submitting: false,
        });
        if (recordNotFound) {
          this.setRecordNotFound();
        }
      })
      .catch((err) => {
        this.setState({
          pageState: { ...pageState, isLoading: true },
          submitting: false,
        });
      });
  };

  check(data) {
    return data.eventMedia != null;
  }

  openDialogVideo = (url, name) => {
    this.setState({
      open: !this.state.openVideo,
      videoToPlay: url,
      videoName: name,
    });
  };

  closeDialog = () => {
    this.setState({ open: !this.state.open });
  };

  openDialogApprove = (btnText, videoPath, row) => {
    this.setState({
      openApprove: !this.state.openApprove,
      videoPath,
      btnText,
      rowData: row,
    });
  };

  closeDialogApprove() {
    this.setState({
      openApprove: !this.state.openApprove,
    });
  }

  sendApproveRequest(status, rowData) {
    const { pageState } = this.state;
    const { setSuccessPopupInformation, setFailPopUpInformation } = this.props;
    //Approving request
    userService
      .approveHighlightRequest(rowData?.id, status)
      .then((res) => {
        //Saving highlight request video
        userService
          .postFeedMergeHighlight({
            eventId: rowData?.schEventId,
            eventMediaId: rowData?.eventMediaId,
            shareOnId: 4,
            schoolId: rowData?.schoolId,
            highlightId: rowData?.id,
          })
          .then((res) => {
            //saved media flag to show on highlight page
            userService
              .sendApproveRequest(res.data?.data?.id, status, rowData?.id)
              .then((res) => {
                this.setState({
                  openApprove: false,
                });
                setSuccessPopupInformation({
                  successPopUp: {
                    message: status
                      ? "Request Approved"
                      : "Request DisApproved",
                    open: true,
                  },
                });
                this.getHighlightsDataByPage(
                  pageState.page,
                  pageState.pageSize
                );
              });
          });
      })
      .catch((error) => {
        this.setState({
          openApprove: false,
        });
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
      });
  }

  handleDisapproveRequest(status, rowData) {
    const { pageState } = this.state;
    const { setSuccessPopupInformation, setFailPopUpInformation } = this.props;
    //Approving request
    userService
      .approveHighlightRequest(rowData?.id, status)
      .then((res) => {
        this.setState({
          openApprove: false,
        });
        setSuccessPopupInformation({
          successPopUp: {
            message: status ? "Request Approved" : "Request DisApproved",
            open: true,
          },
        });
        this.getHighlightsDataByPage(pageState.page, pageState.pageSize);
      })
      .catch((error) => {
        this.setState({
          openApprove: false,
        });
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
      });
  }

  toggleSuccessDialog = () => {
    this.setState({ successPopup: !this.state.successPopup });
  };

  setSearchedRecord = (value) => {
    this.setState({ searchedRecord: value });
  };

  setSearchQuery = (value) => {
    this.setState({ searchQuery: value });
  };

  setRecordNotFound = () => {
    this.setState({ recordNotFound: false });
  };

  //Need to update this api as flow changes
  searchHighlight = (query, page, size) => {
    const { schoolId, searchedRecord, pageState } = this.state;
    this.setState({
      pageState: { ...pageState, isLoading: true },
      searchQuery: query,
    });
    if (!searchedRecord) {
      this.setState({ searchedRecord: true });
    }
    userService
      .searchHighlight(query, page, size)
      .then((res) => {
        this.setState({
          pageState: {
            ...pageState,
            data: res?.data?.data?.highlightDetailsResponse,
            isLoading: false,
            total: res?.data?.data?.total,
            page: page,
          },
          recordNotFound: res.data.data.totalElements == 0 ? true : false,
        });
      })
      .catch((err) => {
        this.setState({
          pageState: {
            ...pageState,
            data: [],
            isLoading: false,
            total: 0,
            page: page,
          },
          recordNotFound: true,
        });
      });
  };

  render() {
    const {
      submitting,
      videoToPlay,
      videoName,
      pageState,
      searchQuery,
      openApprove,
      videoPath,
      btnText,
      searchedRecord,
      recordNotFound,
      redirect,
      open,
      redirectToHighlight,
      loginRole,
      rowData,
    } = this.state;

    if (redirectToHighlight) {
      return <Redirect to="/highlightsdetails" />;
    }

    if (redirect) {
      return <Redirect to="/website" />;
    }

    const tableColumns = [
      {
        field: "videoUrl",
        headerName: "Video",
        headerAlign: "center",
        headerClassName: "table-header bold",
        width: 200,
        sortable: false,
        cellClassName: "custom-cell",
        align: "center",
        renderCell: (params) => (
          <div
            onClick={() => {
              this.openDialogVideo(params.row.videoUrl, params.row.videoName);
            }}
          >
            <video src={params.row.videoUrl} className="thumbnail3" />
          </div>
        ),
      },
      {
        field: "schoolName",
        headerName: "School Name",
        headerAlign: "center",
        headerClassName: "table-header bold",
        width: 350,
        sortable: false,
        cellClassName: "custom-cell",
        renderCell: (params) => (
          <div className="d-flex-align-cent height-70 w-100">
            <p className="link-blue text-width-auto mg-auto">
              {params?.row?.schoolName}
            </p>
          </div>
        ),
      },
      {
        field: "createdAt",
        headerName: "Created At",
        width: 300,
        align: "center",
        headerClassName: "table-header bold",
        sortable: false,
        headerAlign: "center",
        renderCell: (params) => (
          <div>
            <p>{new Date(params.row.createdAt).toLocaleDateString()}</p>
          </div>
        ),
      },
      {
        field: "approval",
        headerName: "Action",
        width: 300,
        sortable: false,
        align: "center",
        headerAlign: "center",
        headerClassName: "table-header bold",
        renderCell: (params) => (
          <div className="actionContainer">
            {params.row.isApproved && (
              <span className="approved">
                <GridCheckCircleIcon fontSize="small" /> Approved
              </span>
            )}
            {params.row.isRejected && (
              <span className="disapproved">
                <ClearIcon className="clearIcon" fontSize="small" /> Rejected
              </span>
            )}
            {!params.row.isApproved && !params.row.isRejected && (
              <>
                <button
                  className="approve-bttn"
                  onClick={() => {
                    this.openDialogApprove(
                      "Approve",
                      params.row.videoUrl,
                      params.row
                    );
                  }}
                >
                  Approve
                </button>
                <button
                  className="disapprove-bttn"
                  onClick={() => {
                    this.openDialogApprove(
                      "DisApprove",
                      params.row.videoUrl,
                      params.row
                    );
                  }}
                >
                  DisApprove
                </button>
              </>
            )}
          </div>
        ),
      },
      {
        headerClassName: "table-header bold",
        cellClassName: "mng-z-index2",
        headerAlign: "center",
        align: "center",
        sortable: false,
        height: 100,
        renderCell: (params) => (
          <div>
            <ListMenu
              menuContent={menuItemContent(params.row)}
              rowData={params.row}
            />
          </div>
        ),
      },
    ];

    const menuItemContent = (data) => {
      const notDeleted = [
        {
          id: "1",
          name: "Delete",
          icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
          ApiCall: () => deleteRequestDialog(data),
        },
      ];
      return notDeleted;
    };

    const deleteRequestDialog = (item) => {
      const { setConfirmationPopupInformation } = this.props;
      //currently we deleted the request but we need to update shareVideoHighlight flag for approved highlight to remove highlight from highlight page
      setConfirmationPopupInformation({
        confirmationPopup: {
          open: true,
          message: "Are You Sure, You Want To Delete Request?",
          btnColor: "red",
          btnText: "Yes",
          id: item.id,
          shareMediaId: item.shareMediaId,
          type: "Delete create highlight Request",
        },
        confirmationAction: () => {
          this.getHighlightsDataByPage(pageState.page, pageState.pageSize);
        },
      });
    };

    const handleApprovalClick = () => {
      this.setState({
        buttonDisable: true,
      });
      if (btnText == "Approve") {
        this.sendApproveRequest(true, rowData);
      } else {
        this.handleDisapproveRequest(false, rowData);
      }
      this.setState({
        buttonDisable: false,
      });
    };

    return (
      <>
        {loginRole === "SUPER ADMIN" ? (
          <div>
            <div className="content-layout pt-20">
              <SuperAdminDashboard />

              <div className="mng-header stickyy">
                <h4 className="fs-20 bold mob-hd">
                  <span
                    className="custom-back-button-icon mg-right-10 cp"
                    onClick={() => this.setState({ redirect: true })}
                  >
                    <ArrowBackIcon className="backarrow-icon" />
                  </span>
                  MANAGE HIGHLIGHTS ({this.state.pageState.total})
                </h4>
              </div>
              <div className="clear10"></div>
              {submitting && (
                <div className="content-layout-loading-animation">
                  <CircularProgress sx={{ fontSize: 10, color: "#002244" }} />
                </div>
              )}
              <div
                id="mtablestyle"
                className="col-12 col-sm-12 col-md-12 col-lg-12 plr "
              >
                {!submitting &&
                  (pageState.data.length > 0 || recordNotFound) && (
                    <Paper className="pad-top-20 mg-bottom-20">
                      <CustomSearch
                        searchQuery={searchQuery}
                        setSearchQuery={this.setSearchQuery}
                        setSearchedRecord={this.setSearchedRecord}
                        searchedRecord={searchedRecord}
                        getDataByPage={this.getHighlightsDataByPage}
                        pageState={pageState}
                        searchData={this.searchHighlight}
                        setRecordNotFound={this.setRecordNotFound}
                      />
                      <DataGrid
                        rows={pageState?.data}
                        rowCount={pageState?.total}
                        loading={pageState?.isLoading}
                        pagination
                        page={pageState?.page}
                        columns={tableColumns}
                        pageSize={pageState?.pageSize}
                        rowsPerPageOptions={[10]}
                        paginationMode="server"
                        getRowId={(row) => row?.id}
                        onPageChange={(newPage) => {
                          if (searchQuery == "") {
                            this.getHighlightsDataByPage(newPage, 10);
                          } else {
                            this.searchHighlight(searchQuery, newPage, 10);
                          }
                          this.setState({ ...pageState, page: newPage });
                        }}
                        onPageSizeChange={(newPageSize) =>
                          this.setState({
                            ...pageState,
                            pageSize: newPageSize,
                          })
                        }
                        sx={{
                          color: "black",
                          fontFamily: "Rajdhani-SemiBold",
                          fontSize: "18px",
                          backgroundColor: "white",
                          borderBottomLeftRadius: "12px",
                          borderBottomRightRadius: "12px",
                        }}
                        autoHeight
                        disableColumnMenu
                        getRowHeight={() => "auto"}
                        disableSelectionOnClick
                      />
                    </Paper>
                  )}
                {!submitting &&
                  !pageState.data.length > 0 &&
                  !recordNotFound && <ErrorMessage />}
              </div>
              <Dialog
                id="dialogBoxCancel"
                className="updateschool"
                open={openApprove}
                onClose={this.closeDialogApprove.bind(this)}
              >
                <DialogTitle>
                  <div className="row">
                    <div className="col-10">
                      <h1 className="fs-20 semi-bold disapptxt">
                        Highlight Approval
                      </h1>
                    </div>
                    <div className="col-1 text-right ml-auto">
                      <BsXLg
                        onClick={this.closeDialogApprove.bind(this)}
                        className="crossview cp"
                      ></BsXLg>
                    </div>
                  </div>
                  <hr></hr>
                </DialogTitle>
                <DialogContent>
                  <div className="clear10"></div>
                  <div className="row">
                    <div className="col-12 text-center">
                      <ReactPlayer
                        id="videoPlayer1"
                        url={videoPath}
                        playing={false}
                        controls
                        className="w-100 "
                      />
                      <p className="fs-20 semi-bold text-center mb-4 mg-top-20">
                        Are you sure you want to {btnText} this video?
                      </p>
                    </div>
                    <div className="mg-auto">
                      <button
                        type="button"
                        class="cancelbtn"
                        onClick={this.closeDialogApprove.bind(this)}
                      >
                        CANCEL
                      </button>

                      <button
                        style={{ marginLeft: "10px" }}
                        type="button"
                        className="yes-btn"
                        disabled={this.state.buttonDisable}
                        onClick={handleApprovalClick}
                      >
                        {btnText}
                      </button>
                    </div>
                  </div>

                  <div className="clear10"></div>

                  <div className="clear10"></div>
                </DialogContent>
              </Dialog>
              {/* video name pop up */}
              <Dialog
                id="dialogBoxVideonew"
                className="dialog-style"
                open={open}
                onClose={this.closeDialog}
              >
                <DialogTitle>
                  <div className="row">
                    <div className="col-10">
                      <label className="fs-20 vidonametxt">{videoName}</label>
                    </div>
                    <div className="col-1 text-right ml-auto mr-2">
                      <BsXLg
                        onClick={this.closeDialog}
                        className="crossview cp"
                      ></BsXLg>
                    </div>
                  </div>
                </DialogTitle>
                <DialogContent>
                  <div className="row">
                    <ReactPlayer
                      id="videoPlayer2"
                      className="videoPlayer1 img-fluid video1 widevideo1"
                      url={videoToPlay}
                      playing={false}
                      controls
                      alt="EZ"
                    />
                  </div>
                  <div className="clear10"></div>
                  <div className="clear10"></div>
                </DialogContent>
              </Dialog>
            </div>
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSuccessPopupInformation: (obj) => openSuccessPopup(dispatch, obj),
    setFailPopUpInformation: (obj) => openFailDialog(dispatch, obj),
    setConfirmationPopupInformation: (obj) =>
      openConfirmationPopup(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return state;
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(highlightsdetails)
);
